module.exports = __webpack_public_path__ + "static/media/logo-white.a39b1087.svg";